import axios from "axios";

const saveToken = (values) => {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/feedback/save_webToken`, values);
};

export default saveToken;
